// extracted by mini-css-extract-plugin
export var container = "stayintheloop-module--container--1VOpX";
export var leftSide = "stayintheloop-module--leftSide--1yYBi";
export var whitebox = "stayintheloop-module--whitebox--3RWMR";
export var rightSide = "stayintheloop-module--rightSide--jbKFJ";
export var header = "stayintheloop-module--header--29Exw";
export var title = "stayintheloop-module--title--2kKlB";
export var subtitle = "stayintheloop-module--subtitle--3trXQ";
export var subtitleContainer = "stayintheloop-module--subtitleContainer--2cxoT";
export var contact = "stayintheloop-module--contact--2ACci";
export var socials = "stayintheloop-module--socials--2IPBR";
export var socialCardTwitter = "stayintheloop-module--socialCardTwitter--34pS0";
export var socialCardIcon = "stayintheloop-module--socialCardIcon--RiVgE";
export var socialCardInstagram = "stayintheloop-module--socialCardInstagram--1Dibr";
export var socialCardDiscord = "stayintheloop-module--socialCardDiscord--34SQN";
export var socialCardDiscordMobile = "stayintheloop-module--socialCardDiscordMobile--36S9i";
export var socialCardTextBox = "stayintheloop-module--socialCardTextBox--1HiX7";
export var socialCardTextTwitter = "stayintheloop-module--socialCardTextTwitter--1CyiX";
export var socialCardTextInstagram = "stayintheloop-module--socialCardTextInstagram--W4c9r";
export var containerMobile = "stayintheloop-module--containerMobile--2wIZG";
export var rightSideMobile = "stayintheloop-module--rightSideMobile--2muOK";
export var socialsMobile = "stayintheloop-module--socialsMobile--3puyL";
export var socialCardInstagramMobile = "stayintheloop-module--socialCardInstagramMobile--12_7F";
export var titleMobile = "stayintheloop-module--titleMobile--2sNsl";
export var subtitleContainerMobile = "stayintheloop-module--subtitleContainerMobile--1uOSs";
export var headerMobile = "stayintheloop-module--headerMobile--38hL8";
export var contactMobile = "stayintheloop-module--contactMobile--3tGTU";
export var subtitleMobile = "stayintheloop-module--subtitleMobile--2K9MS";